<template>
    <div>
        <carousel v-if="arrDashboard.length > 0"
                  id="BDSDashboardSlider"
                  :responsive="configCarousel.responsive"
                  :margin="10"
                  :lazyLoad="true"
                  :loop="false"
                  :autoplay="false">
            <div v-for="(v,k) in arrDashboard" :key="k" @click="clickDashboard(v)">
                <img :src="v.imageUrl" class="img-fluid"/>
            </div>
        </carousel>
    </div>
</template>
<script>
import Carousel from 'vue-owl-carousel'; // https://github.com/s950329/vue-owl-carousel
import BzbsDashboard from '@/core/Campaign/service/BzbsDashboard.js';
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
import { SubDashboardConfigBuilder } from "@/core/Campaign/model/DashboardConfigModel.js";

/**
 * @property {string} apiConfig (require) Dashboard config_list
 */
export default {
    name: "DashboardSlider",
    components: {
        Carousel,
    },
    props: {
        apiConfig: String,
    },
    data: function() {
        return {
            arrDashboard: [],
            configCarousel: {
                responsive: {
                    0: { items: 1 },
                },
            },
        };
    },
    created: function() {
        this.getDashboard();
    },
    methods: {
        getDashboard: function() {
            var token = Account.getToken();
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(token, params, this.apiConfig).subscribe((data) => {
                this.arrDashboard = data;
            }, (err) => {
                console.log(err);
            });
        },
        clickDashboard: function(dashboard) {
            if (dashboard.type == 'link') {
                window.open(dashboard.url, '_blank');
            } else if (dashboard.type == 'campaign') {
                this.$router.push('/campaign/' + dashboard.id);
            }
        },
    },
}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
</style>
<style lang="scss" scoped>
    .img-fluid {
        border-radius: 8px;
    }
</style>
